export default "__VITE_ASSET__CrgZpBJi__"